<header>
  <h1 #editor contenteditable="true" (paste)="onPaste($event)" [formControl]="formControl" [attr.placeholder]="props.placeholder" [formlyAttributes]="field"></h1>

  <mat-error *ngIf="!field.formControl.untouched && field.formControl.invalid">
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>

  <div class="divider"></div>
</header>
